module.exports = __webpack_public_path__ + "media/images/vacancies-bg-02-f054465a714ad7b02273e4a81d0063d9.png";